import { AuthGuard, CanDeactivateGuard, roleGuard } from "@dis/auth";
import { JtmsRoutes, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    // AuthGuard first: the router acts on the first non-true result in array order.
    canMatch: [AuthGuard, roleGuard(["admin", "super_admin"])],
    data: { navGroup: "admin", adminOnly: true },
    children: [
      groupOverview(),
      {
        path: "users",
        pathMatch: "full",
        data: { navOrder: 1 },
        loadComponent: () => import("../feature/users/users/users").then((m) => m.Users),
        title: "Users",
      },
      {
        path: "users/:uid/access",
        canDeactivate: [CanDeactivateGuard],
        loadComponent: () =>
          import("../feature/users/access-control-manager/access-control-manager.component").then(
            (m) => m.AccessControlManagerComponent
          ),
        title: "Access Control",
      },
      {
        path: "settings",
        data: { navOrder: 2 },
        loadComponent: () => import("../feature/settings/settings/settings.component").then((m) => m.SettingsComponent),
        title: "Settings",
      },
      {
        path: "innovex-regions",
        data: { navOrder: 3 },
        loadComponent: () =>
          import("../feature/settings/innovex-regions/innovex-regions.component").then((m) => m.InnovexRegions),
        title: "Innovex Regions",
      },
    ],
  },
] satisfies JtmsRoutes;
